// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'
import { NewsletterModuleUi } from '@modules/front'

import { Inject } from '@plugin/inversify'
import { IUserComService, UserComServiceType } from '@service/usercom'
import { LocalStorage } from '@movecloser/front-core'
import { UserModel } from '@profile/contracts'

@Component<NewsletterModuleUI>({
  name: 'NewsletterModuleUI'

  // FIXME: Create widget for user.com to
  // mounted (): void {
  //   this.userComService.initializeUserComScript()
  // }
})
export class NewsletterModuleUI extends NewsletterModuleUi {
  //
  @Inject(UserComServiceType)
  protected readonly userComService!: IUserComService

  /**
   * get the current user
   */
  private get user (): UserModel | null {
    return this.$store.getters['profile/me']
  }

  public onSubmit (formData: { email: string | null }): Promise<void> {
    const userComId = LocalStorage.get('d24-user-com-id')

    this.eventBus.emit('newsletter-subscribe', {
      ...formData,
      userId: userComId
    })

    return this.userComService.subscribe(formData)
  }
}
